var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleErrors.length
    ? _c(
        "ul",
        { class: _vm.outerClass },
        _vm._l(_vm.visibleErrors, function(error) {
          return _c("li", {
            key: error,
            class: _vm.itemClass,
            attrs: { role: _vm.role, "aria-live": _vm.ariaLive },
            domProps: { textContent: _vm._s(error) }
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }